/* eslint-disable eag/match-named-export */
/** Shared by detail and listing availability-check pollers. */
export const AVAILABILITY_CHECK_POLLING_INTERVAL_MS = 5_000;

/** Detail: attempt budget. Listing: deadline window after last user-driven load. */
export const AVAILABILITY_CHECK_MAX_DURATION_MS = 120_000;

export const AVAILABILITY_CHECK_MAX_ATTEMPTS = Math.ceil(
  AVAILABILITY_CHECK_MAX_DURATION_MS / AVAILABILITY_CHECK_POLLING_INTERVAL_MS
);

/** Maximum adIds accepted by one availability-check request. */
export const AVAILABILITY_CHECK_MAX_AD_IDS = 1000;
